module.exports = __webpack_public_path__ + "img/Enchantress.0f2bbbea.jpg";